import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Timeago from 'react-timeago';
import { formatDate } from 'utils/formatting';

function addZero(number) {
  return number < 10 ? '0' + number : number;
}

const shortFormatter = new Intl.DateTimeFormat('en', {
  month: '2-digit',
  day: '2-digit'
});

const longFormatter = new Intl.DateTimeFormat('en', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  minutes: '2-digit',
  seconds: '2-digit'
});

function timeSinceFormatter(prefix, nowText, value, unit, suffix, timeStamp) {
  if (
    unit === 'day' ||
    unit === 'week' ||
    unit === 'month' ||
    unit === 'year'
  ) {
    const d = new Date(timeStamp);
    const h = d.getHours();
    const hours = h === 0 || h === 12 ? 12 : h % 12;
    const minutes = addZero(d.getMinutes());
    const tod = h >= 12 ? 'PM' : 'AM';

    let formattedDate = '';
    if (value === 1 && unit === 'day') {
      formattedDate = 'Yesterday';
    } else {
      const now = new Date();
      formattedDate =
        now.getYear() !== d.getYear()
          ? longFormatter.format(d)
          : shortFormatter.format(d);
    }

    return `${prefix} ${formattedDate} at ${hours}:${minutes} ${tod}`.trim();
  } else if (unit === 'second') {
    return nowText
      ? nowText
      : prefix
      ? `${prefix} just now`
      : 'posted just now';
  }

  if (value !== 1) {
    unit += 's';
  }

  return `${prefix} ${value} ${unit} ${suffix}`.trim();
}

function TimeSince({ date, prefix = '', nowText = '' }) {
  const title = formatDate(date, 'full');
  return (
    <Fragment>
      <Timeago
        minPeriod={60}
        date={date}
        formatter={timeSinceFormatter.bind(this, prefix, nowText)}
        title={title}
        aria-hidden="true"
      />
      <span className="sr-only">{`${prefix} ${title}`}</span>
    </Fragment>
  );
}

TimeSince.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  prefix: PropTypes.string,
  nowText: PropTypes.string
};

export default TimeSince;
